export function snapshotWorld(layout) {
    return { ...layout, dungeonArrivals: [...layout.dungeonArrivals] };
}
export function restoreWorld(snapshot) {
    return { ...snapshot, dungeonArrivals: new Map(snapshot.dungeonArrivals) };
}
//# sourceMappingURL=world-snapshot.js.map